import { render } from "./TypePassword.vue?vue&type=template&id=172d9217"
import script from "./TypePassword.vue?vue&type=script&lang=js"
export * from "./TypePassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ab-front-auth/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__